import { IconButton } from "@sidelinesports/fan-design-system";
import { FeedIcon } from "@sidelinesports/icons";
import type { ComponentProps } from "react";

export const LiveFeedTriggerButton = (props: ComponentProps<"button">) => {
  return (
    <IconButton
      id="live-feed-trigger-button"
      icon={<FeedIcon />}
      size="lg"
      variant="outline-light"
      aria-label="Live Feed"
      {...props}
    />
  );
};
